import { TranslateFunction } from '@griply/types';

// The event endpoints answer a failure with the callable protocol's error envelope, and both Firebase
// SDKs surface its `details` on the thrown error. `code` is the stable token; the `message` beside it is
// English-only, which is why it is never rendered — it exists for Sentry and for the logs.
const KNOWN_CODES = [
  'untranslatable-recurrence',
  'video-call-not-removable',
  'connection-unavailable',
  'connection-cannot-write-events',
  'provider-rejected',
  // the UI gates this before the call, so reaching it means an out-of-date client or a lapsed plan
  'premium-required',
  // Not expressible on either provider; the occurrence prompt steers around it, this is the backstop.
  'occurrence-not-movable',
  // Deleted or moved by hand while the editor was open; only a move can hit it.
  'event-gone',
];

const getErrorCode = (error: unknown): string | null => {
  const details = (error as { details?: unknown })?.details;
  const code = (details as { code?: unknown })?.code;
  return typeof code === 'string' ? code : null;
};

// A code this build has no copy for falls back to the generic description rather than to the provider's
// own wording — an untranslated English sentence in a Dutch dialog reads as a bug, not as detail.
export const getCalendarEventErrorMessage = (
  error: unknown,
  t: TranslateFunction,
): string => {
  const code = getErrorCode(error);
  if (!code || !KNOWN_CODES.includes(code)) {
    return t('forms.event.error.description');
  }

  return t(`forms.event.errors.${code}`);
};
